module.exports = __webpack_public_path__ + "static/media/delivered.4f79fd0b.svg";